import { AfterContentChecked, Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "session-expired-modal",
  templateUrl: "./session-expired-modal.component.html",
  styleUrls: ["./session-expired-modal.component.css"],
})
export class SessionExpiredModalComponent implements AfterContentChecked {
  constructor(@Inject(MAT_DIALOG_DATA) public message: any,
              private translate: TranslateService) {
  }

  ngAfterContentChecked() {
    this.message = this.translate.instant("idle.sessionExpired");
  }

  onDialogClick(): void {
  }
}
